<template>
  <div class="info-icon">
    <md-icon class="text-info">info_outline</md-icon>
    <md-tooltip md-direction="bottom">on bottom</md-tooltip>
  </div>
</template>

<script>
export default {
  name: 'InfoIcon',
}
</script>

<style scoped></style>
